import React, { useRef } from "react";
import { usePopover, Overlay, DismissButton } from "@react-aria/overlays";
import styled from "styled-components";

export function Popover(props) {
  const ref = useRef(null);
  const { state, children } = props;

  const { popoverProps, underlayProps } = usePopover(
    { ...props, popoverRef: ref },
    state
  );

  // Add a hidden <DismissButton> component at the end of the popover
  // to allow screen reader users to dismiss the popup easily.
  return (
    <Overlay>
      <div {...underlayProps} style={{ display: "fixed", inset: 0 }} />
      <Container {...popoverProps} ref={ref}>
        <DismissButton onDismiss={state.close} />
        {children}
        <DismissButton onDismiss={state.close} />
      </Container>
    </Overlay>
  );
}

const Container = styled.div`
  background-color: #fff;
  border: 1px solid #00000029;
  border-radius: 25px;
  position: absolute;
  z-index: 10;
  top: 100%;
  box-shadow: 0px 5px 10px #00000029;
  margin-top: 0.75rem;
  padding: 1rem;
  outline: none;
  overflow: auto;
`;
